import { Ref, ref } from 'vue'
import { LocationQueryValue } from 'vue-router'

import { StateField, StateFieldConfig } from '../StateField'

export type BooleanStateFieldConfig = StateFieldConfig<BooleanStateField> & {
  type: 'boolean'
  default?: boolean
  overrideValue?: Ref<boolean>

  checkboxLabel?: string
}

export class BooleanStateField extends StateField {
  readonly type = 'boolean'
  default: boolean = false
  value: Ref<boolean>

  checkboxLabel?: string

  constructor(config: BooleanStateFieldConfig) {
    super(config)

    this.value = config.overrideValue || ref(config.default || false)
    this.default = config.default || false
    this.checkboxLabel = config.checkboxLabel
  }

  toRouteValue(): string | undefined {
    if (this.toRouteValueOverride) return this.toRouteValueOverride(this)

    if (this.default === this.value.value) return undefined

    return this.value.value ? 'true' : 'false'
  }

  pullRouteQueryValue(value: LocationQueryValue | LocationQueryValue[]): void {
    if (this.pullRouteQueryValueOverride)
      return this.pullRouteQueryValueOverride(this, value)

    if (value) {
      if (value.toString() === 'true') this.value.value = true
      else if (value.toString() === 'false') this.value.value = false
      else this.value.value = this.default
    } else {
      this.value.value = this.default || false
    }
  }

  pullRouteParamValue(value: string | string[]): void {
    if (this.pullRouteParamValueOverride)
      return this.pullRouteParamValueOverride(this, value)

    if (value) {
      if (value.toString() === 'true') this.value.value = true
      else if (value.toString() === 'false') this.value.value = false
      else this.value.value = this.default
    } else {
      this.value.value = this.default || false
    }
  }

  async toRequestVariable(variation: number): Promise<boolean> {
    if (this.toRequestVariableOverride)
      return await this.toRequestVariableOverride(this, variation)

    return this.value.value
  }

  resetValue(): void {
    if (this.resetValueOverride) return this.resetValueOverride(this)

    this.value.value = this.default || false
  }
}
